
        <div class="dialog-wrap">
            <div class="dialog-header">
                <mat-icon>loyalty</mat-icon>
                <span>Apply Discount or Promo</span>
                <button class="close-btn" (click)="close(null)"><mat-icon>close</mat-icon></button>
            </div>

            <!-- Tab bar -->
            <div class="tab-bar">
                <button class="tab-btn" [class.active]="activeTab === 'discount'" (click)="activeTab = 'discount'">
                    <mat-icon>discount</mat-icon> Custom Discount
                </button>
                <button class="tab-btn" [class.active]="activeTab === 'promo'" (click)="activeTab = 'promo'">
                    <mat-icon>local_offer</mat-icon> Rewards & Promo
                </button>
            </div>

            <div class="dialog-body">
                <!-- Custom Discount Tab -->
                <div *ngIf="activeTab === 'discount'" class="discount-tab">
                    <div class="discount-error" *ngIf="discountError">{{ discountError }}</div>
                    <div class="discount-input-wrap">
                        <input *ngIf="discountType === 'amount'" type="text" class="discount-input"
                               placeholder="Enter Amount" [ngModel]="discountValue"
                               (ngModelChange)="onAmountChange($event)">
                        <span *ngIf="discountType === 'percent'" class="percent-wrap">
                            <input type="number" class="discount-input" placeholder="Enter Percent"
                                   [(ngModel)]="discountValue">%
                        </span>
                    </div>
                    <div class="type-toggle">
                        <button class="toggle-btn" [class.active]="discountType === 'amount'"
                                (click)="discountType = 'amount'; discountValue = ''; discountError = ''">Amount</button>
                        <button class="toggle-btn" [class.active]="discountType === 'percent'"
                                (click)="discountType = 'percent'; discountValue = ''; discountError = ''">Percentage</button>
                    </div>
                </div>

                <!-- Rewards & Promo Tab -->
                <div *ngIf="activeTab === 'promo'">
                    <app-checkout-rewards
                        [orderTotal]="data.orderTotal"
                        [lineItems]="data.lineItems || []"
                        [rewardsEnabled]="data.rewardsEnabled !== false"
                        (selectionChange)="onChange($event)">
                    </app-checkout-rewards>
                </div>
            </div>

            <div class="dialog-actions">
                <button class="cancel-btn" (click)="close(null)">Cancel</button>
                <button class="apply-btn" [disabled]="!canApply()" (click)="apply()">
                    Apply
                </button>
            </div>
        </div>
    